import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { getters } from '@/store/modules/pronostico-hidrico-estacion/getters'
import { actions } from '@/store/modules/pronostico-hidrico-estacion/actions'
import { mutations } from '@/store/modules/pronostico-hidrico-estacion/mutations'
import { PronosticoHidricoEstacionState } from '@/store/modules/pronostico-hidrico-estacion/types'
// @ts-ignore
export const state: PronosticoHidricoEstacionState = {
  estacionResumen: [{
    pronostico_horario: [],
    id: 0,
    nombre: '',
    valor_list: [],
    institucion: ''
  }],
  link_descarga: '',
  error: { state: false }
}

const namespaced: boolean = true

export const pronosticoHidricoEstacion: Module<PronosticoHidricoEstacionState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
